import { EventData, VdpEventData } from 'lib/EventLogger/Event';
import { EventType, SourcePages, ViewTypes } from 'lib/EventSchema';
import { VehicleEventInfo } from 'lib/Tracking/types';

type VdpPageViewEventData = VehicleEventInfo & { sourceUrl?: string };

export default function VdpPageViewEvent({
  trackingParams,
  sourceUrl,
}: VdpPageViewEventData): EventData & VdpEventData {
  const eventData = {
    event_type: EventType.view,
    source_page: SourcePages.Vdp,
    view_type: ViewTypes.pageView,
    event_context: {
      tracking_params: trackingParams,
    },
  } as EventData;

  if (sourceUrl) eventData.event_context!.url = sourceUrl;

  return eventData;
}
